import styled from 'styled-components'
import { v1 as color } from 'sidecar-design-library'

import BaseIcon from '../../IconV1'
import BaseListActionItem from '../ListActionItem'

export const Icon = styled(BaseIcon)`
  color: ${color.GREY};
  margin: 0 0.625rem 0 0;
`

export const ListActionItem = styled(BaseListActionItem)`
  padding: 0.9375rem 0;

  // the p tag is actually a child of the Label span
  & span {
    & p {
      color: ${color.GREY};
      font-size: 0.875rem;
      margin-left: 1.875rem;
      margin-bottom: 0;
    }
  }

  &:before,
  &:after {
    left: 0;
    right: 0;
  }
`

export const ListDocumentItem = styled.div`
  position: relative;
`

export const TrashIcon = styled(BaseIcon)`
  position: absolute;
  right: 1.875rem;
  top: 1.25rem;
  font-size: 1.5625rem;
  color: ${color.AQUAMARINE};

  &:hover {
    cursor: pointer;
    color: ${color.SCOOTER};
  }
`
